import { useEffect } from 'react'

import { navigate, useParams } from '@cedarjs/router'

import { useAuth } from '../auth'

import { useHomePage } from './use-home-page'

const REDIRECT_TO_STORAGE_KEY = 'redirectTo'

/** Persists post-auth navigation target (same key read by `useAuthRedirect`). */
export const setRedirect = (path: string) => {
  localStorage.setItem(REDIRECT_TO_STORAGE_KEY, path)
}

export const getRedirect = () => localStorage.getItem(REDIRECT_TO_STORAGE_KEY)

export const clearRedirect = () => {
  localStorage.removeItem(REDIRECT_TO_STORAGE_KEY)
}

export const useAuthRedirect = (redirectCondition?: () => boolean) => {
  const { isAuthenticated } = useAuth()

  const { redirectTo: inputRedirectTo } = useParams()

  useEffect(() => {
    if (inputRedirectTo) {
      setRedirect(inputRedirectTo)
    }
  }, [inputRedirectTo])

  const defaultRedirect = useHomePage()
  const redirectTo = getRedirect() || inputRedirectTo || defaultRedirect

  if (redirectCondition?.() || isAuthenticated) {
    navigate(redirectTo)
  }

  return redirectTo
}
